module.exports = __webpack_public_path__ + "img/driedfruitsSmall.60363733.jpg";